import { FlexCol } from '@/components/common/Flex';
import { FlexProps } from '@chakra-ui/react';
import { FC } from 'react';

export interface PageSectionProps extends FlexProps {
    innerProps?: FlexProps;
    outerChildren?: React.ReactNode;
}

const PageSection: FC<PageSectionProps> = ({
    children,
    maxW = '6xl',
    innerProps = {},
    outerChildren,
    ...props
}) => {
    return (
        <FlexCol align="center" w="full" {...props}>
            <FlexCol h="full" maxW={maxW} w="full" px={8} {...innerProps}>
                {children}
            </FlexCol>
            {outerChildren}
        </FlexCol>
    );
};

export default PageSection;
